import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getData } from "../../../api/api";

export default function LearningOutcomes() {
  const { id } = useParams();
  const [retreat, setRetreat] = useState({});

  useEffect(() => {
    getData(`/retreats/${id}`)
      .then((e) => {
        console.log(e.data);
        setRetreat(e.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);
if (!retreat.retreatLearningOutcomes) {
  return <div>Loading...</div>;
}

  return (
    <div className="container mx-auto p-8">
      <h1 className="text-3xl font-bold mb-6">Learning Outcomes</h1>
      <div className="space-y-6">
        
        {retreat?.retreatLearningOutcomes?.map((data) => (
          <div
            key={data.id}
            className="p-6 border border-gray-300 rounded-lg shadow hover:shadow-md transition-shadow duration-200"
          >
            <h2 className="text-2xl font-semibold mb-2">{data.title}</h2>
            {data.subTitle && (
              <h3 className="text-xl font-medium mb-2 text-gray-700">
                {data.subTitle}
              </h3>
            )}
            <p className="text-gray-800">{data.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
